import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchStockIssueCategoryDetail(id) {
  const { data: raw } = await request.get(`/system/stock-issue-category/${id}`);
  return parseVer4DetailResponse(raw);
}
